"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class UserHasReachedMaximumNumberOfActiveClasses extends client_library_1.ExtendableError {
    constructor(message) {
        super(message);
        this.message = message;
    }
}
exports.default = UserHasReachedMaximumNumberOfActiveClasses;
//# sourceMappingURL=UserHasReachedMaximumNumberOfActiveClasses.js.map